import { type ComponentRadius, radiusCva, useProvider } from "@overmap-ai/blocks"
import { cx } from "class-variance-authority"
import { type ComponentPropsWithRef, memo, useMemo } from "react"
import { twMerge } from "tailwind-merge"

export interface IconWrapperProps extends ComponentPropsWithRef<"div"> {
	inline?: boolean
	background?: boolean
	color?: string
	radius?: ComponentRadius
}

export const IconWrapper = memo<IconWrapperProps>((props) => {
	const providerContext = useProvider()
	const {
		ref,
		children,
		className,
		color,
		inline = false,
		background = false,
		style,
		radius = providerContext.radius,
		...rest
	} = props

	const computedStyle = useMemo(() => {
		return {
			...(background ? { backgroundColor: color ? `${color}20` : "var(--base-a4)" } : {}),
			...style,
		}
	}, [background, color, style])

	return (
		<div
			ref={ref}
			className={twMerge(
				cx(
					"inline-block size-max p-0.5",
					{
						"-m-0.5": inline,
					},
					{
						"backdrop-blur-3xl": background,
					},
					radiusCva({ radius, maxLarge: false }),
					className,
				),
			)}
			style={computedStyle}
			{...rest}
		>
			{children}
		</div>
	)
})
IconWrapper.displayName = "IconWrapper"
